var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { eventManager } from './eventManager';
import { EventActions } from '../utils';
import { isNumber, Type, isString } from '../utils';
var containers = new Map();
var latestInstance;
var queue = [];
var TOAST_ID = 1;
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */
function getToast(toastId) {
    var container = containers.get(latestInstance);
    return container && container.getToast(toastId);
}
/**
 * Generate a random toastId
 */
function generateToastId() {
    return "".concat(TOAST_ID++);
}
/**
 * Generate a toastId or use the one provided
 */
function getToastId(options) {
    return options && (isString(options.toastId) || isNumber(options.toastId))
        ? options.toastId
        : generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */
function dispatchToast(options) {
    if (containers.size > 0) {
        eventManager.emit(EventActions.Show, options);
    }
    else {
        queue.push({ options: options });
    }
    return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */
function mergeOptions(type, options) {
    return __assign(__assign({}, options), { type: (options && options.type) || type, toastId: getToastId(options) });
}
function createToastByType(type) {
    return function (options) { return dispatchToast(mergeOptions(type, options)); };
}
function toast(options) {
    return dispatchToast(mergeOptions(Type.SUCCESS, __assign({}, options)));
}
toast.success = createToastByType(Type.SUCCESS);
toast.info = createToastByType(Type.INFO);
toast.error = createToastByType(Type.ERROR);
toast.warning = createToastByType(Type.WARNING);
/**
 * Remove toast programmaticaly
 *
 * if want to clear all just call without id
 */
toast.dismiss = function (id) {
    if (containers.size > 0) {
        eventManager.emit(EventActions.Clear, id);
    }
    else {
        queue = queue.filter(function (t) { return id != null && t.options.toastId !== id; });
    }
};
/**
 * return true if one container is displaying the toast
 */
toast.isActive = function (id) {
    var isToastActive = false;
    containers.forEach(function (container) {
        if (container.isToastActive && container.isToastActive(id)) {
            isToastActive = true;
        }
    });
    return isToastActive;
};
toast.update = function (toastId, options) {
    if (options === void 0) { options = {}; }
    // if you call toast and toast.update directly nothing will be displayed
    // this is why I defered the update
    setTimeout(function () {
        var toast = getToast(toastId);
        if (toast) {
            var oldOptions = toast.props;
            var nextOptions = __assign(__assign(__assign({}, oldOptions), options), { toastId: options.toastId || toastId, updateId: generateToastId() });
            if (nextOptions.toastId !== toastId)
                nextOptions.staleId = toastId;
            delete nextOptions.render;
            dispatchToast(nextOptions);
        }
    }, 0);
};
toast.onChange = function (callback) {
    eventManager.on(EventActions.Change, callback);
    return function () {
        eventManager.off(EventActions.Change, callback);
    };
};
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */
eventManager
    .on(EventActions.DidMount, function (containerInstance) {
    latestInstance = containerInstance;
    containers.set(latestInstance, containerInstance);
    queue.forEach(function (item) {
        eventManager.emit(EventActions.Show, item.options);
    });
    queue = [];
})
    .on(EventActions.WillUnmount, function (containerInstance) {
    containers.delete(containerInstance);
    if (containers.size === 0) {
        eventManager.off(EventActions.Show).off(EventActions.Clear);
    }
});
export { toast };
